import * as Constants from '@rideiq/constants';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface RidersTablePrefsStore {
  perPage: number;
  setPerPage: (perPage: number) => void;
}

export const useRidersTablePrefsStore = create<RidersTablePrefsStore>()(
  persist(
    (set) => ({
      perPage: Constants.DEFAULT_ROWS_PER_PAGE,
      setPerPage: (perPage) => set({ perPage }),
    }),
    { name: 'ridersTablePrefs', storage: createJSONStorage(() => localStorage) }
  )
);
